// CONSTANT FOR FORM
import { clientSelectControl, locationSelectControl } from '../../../../../constants/form-control/employee/assign-location';

// DATA TYPES
import { FormControlUtil } from '../../../../../core/utils/form-control';

// CONSTANT
import { SAVE_BUTTON_CONFIG } from '../../../../../../app/constants/button';
import { ASSIGN_LOCATION_BUTTON_CONSTANT } from '../../../../../../app/constants/translate-messages/button';
import { ButtonConfig } from '../../../../../../app/models/common/forms/button';
import { NoRecordFound, NoRecordType } from '../../../../../models/common/table/table-config';
import { EMPLOYEE_MESSAGES } from '../../../../../constants/no-record-found/employee';
import { MasterService } from '../../../../../state/master/services/master.service';

/**
 * This constant used for Assign Location Form
 */
export const ASSIGN_LOCATION_FORM_CONTROLS = {
  client: FormControlUtil.mergeFormControl(clientSelectControl, { key: 'client' }),
    location: FormControlUtil.mergeFormControl(locationSelectControl, { key : 'location'}),
};


/**
 * Button config
 */
export const CUSTOM_SAVE_BUTTON_CONFIG: ButtonConfig = FormControlUtil.mergeFormControl(
  SAVE_BUTTON_CONFIG,
  {
    options: FormControlUtil.mergeFormControl(SAVE_BUTTON_CONFIG.options, {
      text: 'Save Assign ' +  MasterService.masterBusinessLabel.Location,
    }),
  },
);

export const noRecordFound: NoRecordFound = {
  type: NoRecordType.BASIC,
  title: EMPLOYEE_MESSAGES.ASSIGN_LOCATION_NO_RECORD_TITEL,
  message: '',
  show: true,
  iconSVG: 'assets/media/iq-svg/animation/new-created-list/no_location.json',
}
